import { ApiResponse,} from "@/types";
import { Transaction as TransactionType, TransactionTable } from "@/types/pos/transaction";
import { apiSlice } from "@/redux/apiSlice";
import { PaymentReportTable } from "@/types/pos/payment-reports";
import { RevenueReportResponse } from "@/types/pos/revenue-report";
import { ForeeReportResponse } from "@/types/pos/foree-report";
import { SRBReportTableResponse } from "@/types/pos/srb-report";
interface transactionInput {
  query: string;
  counter_id: number;
  org_id: number;
}

export const Transaction = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      createTransaction: builder.mutation<ApiResponse, TransactionType>({
        query: (transactionbody) => ({
          url: `/pos/transactions`,
          method: "POST",
          body: transactionbody,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["Transaction", "Invoice","SysConfig","Facility","DHAccounting", "Product"],
      }),
      updateTransaction: builder.mutation<ApiResponse, TransactionType>({
        query: (transactionbody) => ({
          url: `/pos/transactions/${transactionbody.id}`,
          method: "PUT",
          body: transactionbody,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["Transaction", "Invoice","SysConfig","Facility","DHAccounting", "Product"],
      }),
      getTransaction: builder.query<TransactionTable, transactionInput>({
        query: (searchCretiria) => ({
          url: `/pos/transactions?org_id=${searchCretiria.org_id}&counter_ids=${searchCretiria.counter_id}${
            searchCretiria.query.length > 0 ? "&" + searchCretiria.query : ""
          }`,

          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Transaction", "Invoice","SysConfig","Facility","DHAccounting", "Product"],
      }),
      getTransactionById: builder.query<
        TransactionType,
        { transaction_id: number, org_id: number }
      >({
        query: (payload) => ({
          url: `/pos/transactions/${payload.transaction_id}?org_id=${payload.org_id}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Transaction", "Invoice","SysConfig","Facility"],
      }),
      patchTransaction: builder.mutation<ApiResponse, { status: string; id: number }>({
        query: (payload) => ({
          url: `/pos/transactions/${payload.id}/status`,
          method: "PATCH",
          body: { status: payload.status },
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["Transaction","Facility","DHAccounting"],
      }),
      erpTransaction: builder.mutation<any, number>({
        query: (transactionId) => ({
          url: `/pos/transactions/${transactionId}/erp-transaction`,
          method: "POST",
          body: {},
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["Transaction", "Invoice","SysConfig","Facility","DHAccounting"],
      }), 
      srbTransaction: builder.mutation<any, number>({
        query: (transactionId) => ({
          url: `/pos/transactions/${transactionId}/submit-srb`,
          method: "PUT",
          body: {},
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["Transaction", "Invoice","SysConfig","Facility","DHAccounting", "Product"],
      }),
      retryTaxSubmission: builder.mutation<
        any,
        { transaction_id: number; tax_type: string; org_id: number }
      >({
        query: (payload) => ({
          url: `/pos/transactions/${payload.transaction_id}/tax-submittion?org_id=${payload.org_id}`,
          method: "POST",
          body: { tax_type: payload.tax_type },
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["Transaction", "Invoice","SysConfig","Facility", "Product"],
      }),
      // Sales Report API - fetches all transactions across organization
      getSalesReport: builder.query<TransactionTable, { query: string, org_id: number }>({
        query: (searchCriteria) => ({
          url: `/pos/transactions?org_id=${searchCriteria.org_id}${searchCriteria.query.length > 0 ? "&" + searchCriteria.query : ""}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Transaction", "Invoice","SysConfig","Facility","DHAccounting"],
      }),
      getSalesReportForExport: builder.query<TransactionTable, { query: string, org_id:number }>({
        query: (searchCriteria) => ({
          url: `/pos/transactions?offset=0&org_id=${searchCriteria.org_id}${searchCriteria.query.length > 0 ? "&" + searchCriteria.query : ""}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Transaction", "Invoice","SysConfig","Facility","DHAccounting", "Product"],
      }),
    getPaymentReport: builder.query<PaymentReportTable, { query: string, org_id: number }>({
        query: (searchCriteria) => ({
          url: `/pos/transactions/payment-report?org_id=${searchCriteria.org_id}${searchCriteria.query.length > 0 ? "&" + searchCriteria.query : ""}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Transaction", "Invoice","SysConfig","Facility","DHAccounting", "Product"],
      }),
      getDailyCashReport: builder.query<TransactionTable, { query: string, org_id: number }>({
        query: (searchCriteria) => ({
          url: `/pos/transactions/daily-cash?org_id=${searchCriteria.org_id}${searchCriteria.query.length > 0 ? "&" + searchCriteria.query : ""}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Transaction", "Invoice","SysConfig","Facility","DHAccounting"],
      }),
      getDailyCashReportForExport: builder.query<TransactionTable, { query: string }>({
        query: (searchCriteria) => ({
          url: `/pos/transactions/daily-cash?offset=0${searchCriteria.query.length > 0 ? "&" + searchCriteria.query : ""}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Transaction", "Invoice","SysConfig","Facility","DHAccounting", "Product"],
      }),
      getForeeReport: builder.query<ForeeReportResponse, { query: string, org_id: number }>({
        query: (searchCriteria) => ({
          url: `/pos/transactions/foree-report?org_id=${searchCriteria.org_id}${searchCriteria.query.length > 0 ? "&" + searchCriteria.query : ""}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Transaction", "Invoice","SysConfig","Facility","DHAccounting", "Product"],
      }),
      getTransactionItems: builder.query<RevenueReportResponse, { query: string, org_id: number }>({
        query: (searchCriteria) => ({
          url: `/pos/transactions/revenue-report?org_id=${searchCriteria.org_id}${searchCriteria.query.length > 0 ? "&" + searchCriteria.query : ""}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Transaction", "Invoice", "SysConfig", "Facility", "DHAccounting", "Product"],
      }),
      getTransactionTaxesReport: builder.query<SRBReportTableResponse, { query: string, org_id: number }>({
        query: (searchCriteria) => ({
          url: `/pos/transactions/taxes-report?org_id=${searchCriteria.org_id}${searchCriteria.query.length > 0 ? "&" + searchCriteria.query : ""}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Transaction"],
      }),
      getTransactionTaxesReportForExport: builder.query<SRBReportTableResponse, { query: string, org_id: number }>({
        query: (searchCriteria) => ({
          url: `/pos/transactions/taxes-report?org_id=${searchCriteria.org_id}&offset=0${searchCriteria.query.length > 0 ? "&" + searchCriteria.query : ""}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Transaction"],
      }),
    };
  },
});

export const {
  useCreateTransactionMutation,
  useUpdateTransactionMutation,
  useGetTransactionQuery,
  useGetTransactionByIdQuery,
  useLazyGetTransactionByIdQuery,
  usePatchTransactionMutation,
  useErpTransactionMutation,
  useSrbTransactionMutation,
  useGetSalesReportQuery,
  useLazyGetSalesReportForExportQuery,
  useGetPaymentReportQuery,
  useLazyGetPaymentReportQuery,
  useGetTransactionItemsQuery,
  useLazyGetTransactionItemsQuery,
  useGetForeeReportQuery,
  useLazyGetForeeReportQuery,
  useGetDailyCashReportQuery,
  useLazyGetDailyCashReportForExportQuery,
  useGetTransactionTaxesReportQuery,
  useLazyGetTransactionTaxesReportForExportQuery,
  useRetryTaxSubmissionMutation,
} = Transaction;
